/**
 * Fill these in before publishing. They appear on the Privacy Policy and
 * Terms of Service pages.
 */
export const LEGAL = {
  /** Who runs the site, e.g. your name or company. */
  operator: 'Stuffly LLC',
  /** Where people can reach you about privacy or the terms. Empty = shown as "not yet provided". */
  contactEmail: 'support@stuffly.co',
  /** Governing law for the terms, e.g. "the State of California, USA". Empty = clause omitted. */
  jurisdiction: 'the State of California, USA',
  effectiveDate: 'October 25, 2026',
};
